import { constructFrom as e } from "../constructFrom.js";
function m(n, ...o) {
  const r = e.bind(
    null,
    n || o.find((t) => typeof t == "object")
  );
  return o.map(r);
}
export {
  m as normalizeDates
};
